import { Box, Grid, Typography } from "@mui/material";
import styles from '../ServicesMenu/services.module.scss';
import { CommonButton } from "../common/StyledComponents/StyledFields";
import { useState } from "react";
import CommonDonationPopup from "../home/CommonDonationPopup";
import { authService } from "../../infrastructure/backendService";
import { useNavigate } from "react-router-dom";

const Cultural = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const handleDonate = () => {
    if (authService.isAuthenticated()) {
      navigate("/donations");
    } else {
      setIsOpen(true);
    }
  };

  return (
    <>
      <div className={styles.totalCulturalLayout}>
        <Grid>
        <Typography className={styles.typoGraphyHeading}>Cultural</Typography>
        </Grid>
        <Grid>
          <div className={styles.cardContainer}>
            <div style={{ padding: "24px" }}>
              <Box>
                <img className={styles.images} src="/images/cultural.png" />
              </Box>
              <CommonButton onClick={handleDonate} sx={{ marginTop: "15px" }}>
                Donate for event
              </CommonButton>
            </div>
          </div>
        </Grid>
      </div>
      <CommonDonationPopup isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};
export default Cultural;
